import React from 'react';

interface TypingIndicatorProps {
  userName?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ userName }) => {
  return (
    <div className="message-bubble incoming typing-indicator">
      <div className="typing-animation">
        <span></span>
        <span></span>
        <span></span>
      </div>
      {userName && (
        <div className="message-meta">
          <span style={{ fontSize: '11px', color: '#6b7280' }}>
            {userName} is typing...
          </span>
        </div>
      )}
    </div>
  );
};

export default TypingIndicator;
